/*** IMPORTS FROM imports-loader ***/
var define = false;

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

